import { Link } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function HowItWorksPage() {
  const { t } = useLang();
  return (
    <main data-testid="how-it-works-page">
      <Seo title={t.seo.howItWorks.title} desc={t.seo.howItWorks.desc} />
      <PageHero eyebrow={t.howItWorks.eyebrow} title={t.howItWorks.title} sub={t.howItWorks.sub} />

      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <ol className="relative space-y-10 border-l-2 border-sand/60 pl-10 sm:pl-14">
            {t.howItWorks.steps.map((step, i) => (
              <Reveal key={step.title} delay={0.07 * i}>
                <li className="relative" data-testid={`how-step-${i + 1}`}>
                  <span className="absolute -left-[3.35rem] sm:-left-[4.35rem] top-0 flex h-12 w-12 items-center justify-center rounded-full bg-espresso font-serif text-xl font-semibold text-cream shadow-md">
                    {i + 1}
                  </span>
                  <div className="rounded-2xl border border-sand/50 bg-cream/60 p-6 sm:p-8 transition-colors duration-300 hover:border-terracotta/40 hover:bg-cream">
                    <h2 className="font-serif text-xl sm:text-2xl font-medium text-espresso">{step.title}</h2>
                    <p className="mt-3 text-sm sm:text-base leading-relaxed text-espresso/75">{step.text}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>

          <Reveal className="mt-14">
            <div className="flex items-start gap-3 rounded-2xl border border-teal/30 bg-teal/5 p-6" data-testid="how-it-works-note">
              <Info className="mt-0.5 h-5 w-5 shrink-0 text-teal" />
              <p className="text-sm leading-relaxed text-espresso/85">{t.howItWorks.note}</p>
            </div>
          </Reveal>

          <Reveal className="mt-12 text-center">
            <Link
              to="/services"
              data-testid="how-it-works-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 text-base font-semibold text-white transition-colors duration-300 hover:bg-espresso active:scale-95"
            >
              {t.howItWorks.cta}
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
